export const col = {
  status: { lg: 4, md: 12, xs: 24 },
  basic: { lg: 8, md: 8, xs: 24 },
}
